import { BaseDto } from '../../core';
import { PRODUCT_TYPE, MSDS_POSSESSION_STATUS, PRODUCT_STATUS, FileAttachmentDto } from '../../shared';
import { BadgeDto, MapperDisplayCategoryProduct, ProductOption, BestSellerProductSetting } from '../../dto';
import { DisplayCategory } from '../display-category/display-category.entity';
import { Brand } from '../brand/brand.entity';
import { MapperSaleProduct } from './mapper-sale-product.entity';
export class Product extends BaseDto<Product> {
  constructor(partial?: any) {
    super(partial);
    if (partial.mapperSaleProducts && partial.mapperSaleProducts.length) {
      this.mapperSaleProducts = partial.mapperSaleProducts.map(
        (mapperSaleProduct) => new MapperSaleProduct(mapperSaleProduct)
      );
    }
    this.mergeInvalideCountry();
  }

  id: number | string;
  productType: PRODUCT_TYPE;
  brandId: number;
  englishName: string;
  koreanName: string;
  salesCategoryCode: string;
  images: FileAttachmentDto[];
  badges: BadgeDto[];
  msdsPossessionStatus: MSDS_POSSESSION_STATUS;
  videoUrl: string | null;
  contents: string | null;
  isDisplay: boolean;
  created: Date;
  updated: Date | null;
  mapperDisplayCategoryProducts: MapperDisplayCategoryProduct[];
  displayCategories: DisplayCategory[];
  mapperSaleProducts: MapperSaleProduct[];
  productOptions: ProductOption[];
  brand: Brand;

  minMsrpPriceUSD: number;
  maxMsrpPriceUSD: number;

  minFixedMsrpPriceUSD: number;
  maxFixedMsrpPriceUSD: number;

  minFinalSaleSupplyPriceUSD?: number;
  maxFinalSaleSupplyPriceUSD?: number;
  minFinalSaleSupplyRate?: number;
  maxFinalSaleSupplyRate?: number;

  minSalePriceUSD: number;
  maxSalePriceUSD: number;
  minSupplyRate: number;
  maxSupplyRate: number;
  minMinMoq: number;
  maxMinMoq: number;
  minMaxMoq: number;
  maxMaxMoq: number;

  productStatus: PRODUCT_STATUS;
  bestSellerProductSetting?: BestSellerProductSetting;

  getEmbededUrl() {
    return this.videoUrl ? this.videoUrl.replace('watch?v=', 'embed/') : null;
  }

  mergeInvalideCountry() {
    if (!this.mapperSaleProducts) {
      return;
    }

    return this.mapperSaleProducts.map((saleProduct) => {
      saleProduct.productOption.invalidCountry = [
        ...new Set([...saleProduct.productOption.brand.invalidCountry, ...saleProduct.productOption.invalidCountry]),
      ];
    });
  }

  isInvalidCountry(countryCode: string) {
    const invalidCountries = this.mapperSaleProducts.filter((mapperSaleProduct) =>
      mapperSaleProduct.isInvalidCountry(countryCode)
    );
    return invalidCountries.length > 0 ? true : false;
  }

  findMapperSaleProduct(mapperSaleProduct: MapperSaleProduct) {
    for (const item of this.mapperSaleProducts) {
      if (item.id === mapperSaleProduct.id) {
        return item;
      }
    }
    return null;
  }
}
